import { render, staticRenderFns } from "./PatientTreatmentDetail.vue?vue&type=template&id=3135ce58&lang=pug"
import script from "./PatientTreatmentDetail.vue?vue&type=script&lang=js"
export * from "./PatientTreatmentDetail.vue?vue&type=script&lang=js"
import style0 from "./PatientTreatmentDetail.vue?vue&type=style&index=0&id=3135ce58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports